module.exports = __webpack_public_path__ + "static/img/index-logo.9f90d31d.png";